export const ProjectName = ""
export const BASE_URL = "https://middlewarectl.com/api/"
export const URL_UI = `https://middlewarectl.com/`